import { defineMessages } from 'react-intl';

/** The copy of step 3 for an image (design studio-details a1 to a5). */
export const imageTileMessages = defineMessages({
  styleHint: {
    id: 'app.sml.promote.studio.image.styleHint',
    defaultMessage: 'Where the cover goes. Each preview is your file in {theme}.',
  },
  themeDefault: { id: 'app.sml.promote.studio.image.themeDefault', defaultMessage: '{theme} default' },
  defaultShort: { id: 'app.sml.promote.studio.image.defaultShort', defaultMessage: 'Default' },
  coverCardBenefit: {
    id: 'app.sml.promote.studio.image.coverCard.benefit',
    defaultMessage: 'Your cover in the theme frame. Best when the cover art is strong.',
  },
  coverGroundBenefit: {
    id: 'app.sml.promote.studio.image.coverGround.benefit',
    defaultMessage: 'The cover fills the frame, blurred. The words lead.',
  },
  typeOnlyBenefit: {
    id: 'app.sml.promote.studio.image.typeOnly.benefit',
    defaultMessage: 'Big words, no cover. Loud and clear in a fast feed.',
  },
  momentHintStory: {
    id: 'app.sml.promote.studio.image.momentHintStory',
    defaultMessage: 'What the story says. Each moment is its own file.',
  },
  momentHintFeed: {
    id: 'app.sml.promote.studio.image.momentHintFeed',
    defaultMessage: 'What the post says. Each moment is its own file.',
  },
  momentCountdown: { id: 'app.sml.promote.studio.image.moment.countdown', defaultMessage: 'Countdown' },
  preSaveBenefit: {
    id: 'app.sml.promote.studio.image.moment.preSave.benefit',
    defaultMessage: 'The release date and "Pre-save now".',
  },
  outNowBenefit: {
    id: 'app.sml.promote.studio.image.moment.outNow.benefit',
    defaultMessage: 'OUT NOW over the cover and "Listen now".',
  },
  lyricBenefit: {
    id: 'app.sml.promote.studio.image.moment.lyric.benefit',
    defaultMessage: 'One line of the song, big.',
  },
  countdownBenefit: {
    id: 'app.sml.promote.studio.image.moment.countdown.benefit',
    defaultMessage: 'The days to go, big.',
  },
  announceBenefit: {
    id: 'app.sml.promote.studio.image.moment.announce.benefit',
    defaultMessage: 'The release date, before the song is out.',
  },
  countdownFiles: {
    id: 'app.sml.promote.studio.image.moment.countdown.files',
    defaultMessage: '3 files: 7, 3 and 1 days',
  },
  offNoLyrics: { id: 'app.sml.promote.studio.image.moment.offNoLyrics', defaultMessage: '{title} has no lyrics yet.' },
  offAddLyrics: { id: 'app.sml.promote.studio.image.moment.offAddLyrics', defaultMessage: 'Add the lyrics' },
  offTooNear: {
    id: 'app.sml.promote.studio.image.moment.offTooNear',
    defaultMessage: 'Needs 7 days or more to the release.',
  },
  offChangeDate: { id: 'app.sml.promote.studio.image.moment.offChangeDate', defaultMessage: 'Change the date' },
  shapeHint: { id: 'app.sml.promote.studio.image.shapeHint', defaultMessage: 'Where you post it.' },
  shapePortrait: { id: 'app.sml.promote.studio.image.shape.portrait', defaultMessage: '4:5 portrait' },
  shapePortraitBenefit: {
    id: 'app.sml.promote.studio.image.shape.portrait.benefit',
    defaultMessage: 'Fills more of the feed. Instagram and Facebook.',
  },
  shapeSquare: { id: 'app.sml.promote.studio.image.shape.square', defaultMessage: '1:1 square' },
  shapeSquareBenefit: {
    id: 'app.sml.promote.studio.image.shape.square.benefit',
    defaultMessage: 'Fits every feed and every grid.',
  },
  fromTheme: { id: 'app.sml.promote.studio.image.fromTheme', defaultMessage: 'From your theme' },
  fromThemeColours: { id: 'app.sml.promote.studio.image.fromTheme.colours', defaultMessage: 'Colours' },
  fromThemeFonts: { id: 'app.sml.promote.studio.image.fromTheme.fonts', defaultMessage: 'Fonts' },
  fromThemeTexture: { id: 'app.sml.promote.studio.image.fromTheme.texture', defaultMessage: 'Texture' },
  changeTheme: { id: 'app.sml.promote.studio.image.fromTheme.change', defaultMessage: 'Change theme' },
  textureNone: { id: 'app.sml.promote.studio.image.texture.none', defaultMessage: 'None' },
  textureGrain: { id: 'app.sml.promote.studio.image.texture.grain', defaultMessage: 'Grain' },
  textureGlow: { id: 'app.sml.promote.studio.image.texture.glow', defaultMessage: 'Glow' },
  texturePaper: { id: 'app.sml.promote.studio.image.texture.paper', defaultMessage: 'Paper' },
  previewLive: { id: 'app.sml.promote.studio.image.previewLive', defaultMessage: 'Live' },
  honestNote: {
    id: 'app.sml.promote.studio.image.honestNote',
    defaultMessage: 'This is your file in its final layout. The director can still change the crop of the cover.',
  },
  honestNoteLyric: {
    id: 'app.sml.promote.studio.image.honestNoteLyric',
    defaultMessage:
      'This is your file in its final layout. The director can still pick where the line breaks and the word that lights up.',
  },
});
